import Query from '../../components/Report';

const query = () => new Query('discover-connected-entities-top-entities');

export default query;
